import React from 'react';
import { useTranslation } from 'react-i18next';

interface BrandingSashProps {
  hideBranding?: boolean;
}

/**
 * BrandingSash Component
 *
 * Displays a corner ribbon "powered by SailLab" banner
 * Styled similar to Calendly's corner branding
 *
 * Shows by default unless hideBranding is true (from user.hideSailLabBranding)
 */
const BrandingSash: React.FC<BrandingSashProps> = ({ hideBranding = false }) => {
  const { t } = useTranslation();

  if (hideBranding) return null;

  return (
    <div
      className="absolute top-0 right-0 pointer-events-none overflow-hidden z-10"
      style={{ width: '150px', height: '150px' }}
    >
      {/* Corner ribbon rotated 45 degrees */}
      <div
        className="absolute flex flex-col items-center justify-center shadow-md pointer-events-auto"
        style={{
          position: 'absolute',
          top: '20px',
          right: '-35px',
          width: '150px',
          paddingTop: '6px',
          paddingBottom: '6px',
          backgroundColor: 'var(--brand-color, #2E7AA0)',
          color: '#ffffff',
          fontWeight: 700,
          lineHeight: 1.2,
          textAlign: 'center',
          textDecoration: 'none',
          transform: 'rotate(45deg)',
          transformOrigin: 'center center',
        }}
      >
        <span className="text-xs tracking-wide" style={{ fontSize: '9px' }}>
          {t('booking:branding.poweredBy', 'powered by')}
        </span>
        <span className="text-sm font-bold" style={{ fontSize: '11px' }}>
          {t('booking:branding.sailLab', 'SailLab')}
        </span>
      </div>
    </div>
  );
};

export default BrandingSash;
